import * as Yup from "yup";

import {
  CurrencyPicker,
  OfficeButton,
  PDFRenderer,
  RegularInsurerPicker,
  RegularSelectInput,
  SelectInput,
  Show,
  TextInput,
} from "components";
import { useEffect, useState } from "react";

import _ from "lodash";
import config from "config";
import { useCurrentUser } from "_graphql/cache/auth";
import { useFormik } from "formik";
import { wrapClick } from "utils";

const PaymentAllocationTab = () => {
  const currentUser = useCurrentUser();
  const form = useFormik<any>({
    initialValues: {
      period_from: "",
      period_to: "",
      currency: "",
      insurer: "",
      treaty_type: "",
    },
    onSubmit: (values) => {
      form.setFormikState((state) => ({ ...state, status: "SUBMITTED" }));
      form.setSubmitting(false);
      generateReport(values);
      return;
    },
    validationSchema: Yup.object().shape({
      treaty_type: Yup.string().required("Treaty Type is required"),
      currency: Yup.string().required("Currency is required"),
      insurer: Yup.string().required("Insurer is required"),
      period_from: Yup.date()
        .nullable()
        .required("Period From is required")
        .typeError("Invalid date"),
      period_to: Yup.date()
        .nullable()
        .required("Period To is required")
        .typeError("Invalid date"),
      installment_type: Yup.array().when("treaty_type", {
        is: "NonProportional",
        then: (schema) => schema.min(1, "Installment Type is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      quarters: Yup.array().when("treaty_type", {
        is: "Proportional",
        then: (schema) => schema.min(1, "Quarters is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    initialStatus: "NOT_SUBMIITED",
  });
  const [url, setUrl] = useState("");

  useEffect(() => {
    form.setFormikState((state) => ({ ...state, status: "NOT_SUBMIITED" }));
    form.setSubmitting(false);
  }, [form.values.currency, form.values.date, form.values.cheque]);

  const generateReport = (data: any) => {
    // console.log("data", data);
    const { treaty_type, period_from, period_to, insurer, currency } = data;
    const url = `${config.asset.uri}treaty_payment_allocation/${btoa(
      JSON.stringify({
        insurer_id: insurer,
        currency: [currency],
        from: period_from,
        to: period_to,
        account_periods: treaty_type === "Proportional" ? data.quarters : null,
        installment_type: "",
        emp_id: currentUser?.employee?.employee_id,
      })
    )}`;
    console.log("url", url);
    setUrl(url);
  };

  return (
    <div className="w-full">
      <div className="py-3 flex justify-between">
        <h1 className="font-bold text-primary text-lg">
          Generate Payment Allocation
        </h1>
        <div>
          <OfficeButton
            disabled={form.isSubmitting}
            onClick={wrapClick(form.handleSubmit)}
          >
            {form.isSubmitting ? "Generating ..." : "Generate"}
          </OfficeButton>
        </div>
      </div>
      <form className="bg-white py-6 px-6 h-auto">
        <div className="grid gap-3  grid-cols-2 shadow-sm">
          <div>
            <RegularSelectInput
              id="treaty_type"
              label="Treaty Type"
              options={[
                { label: "Proportional", value: "Proportional" },
                { label: "Non-Proportional", value: "NonProportional" },
              ]}
              placeholder="Treaty Type"
              required={true}
              {...form}
            />
          </div>
          <div>
            <CurrencyPicker
              id="currency"
              label="Currency"
              placeholder="Currency"
              required={true}
              {...form}
            />
          </div>
          <div>
            <RegularInsurerPicker
              id="insurer"
              label="Insurer"
              placeholder="Insurer"
              required={true}
              rawId
              {...form}
            />
          </div>
          <Show if={Boolean(form.values.treaty_type === "NonProportional")}>
            <div className="">
              <SelectInput
                id="installment_type"
                label="Installment Type"
                options={[
                  { label: "Installment", value: "Installment" },
                  { label: "Quarterly", value: "Quarterly" },
                ]}
                multiple
                placeholder="Installment Type"
                required={true}
                {...form}
              />
            </div>
          </Show>
          <Show if={Boolean(form.values.treaty_type === "Proportional")}>
            <div className="">
              <SelectInput
                id="quarters"
                label="Quarters"
                options={[
                  { label: "1st Quarter", value: "FIRSTQUARTER" },
                  { label: "2nd Quarter", value: "SECONDQUARTER" },
                  { label: "3rd Quarter", value: "THIRDQUARTER" },
                  { label: "4th Quarter", value: "FOURTHQUARTER" },
                ]}
                multiple
                placeholder="Quarters"
                required={true}
                {...form}
              />
            </div>
          </Show>
          <div className="">
            <TextInput
              required
              id={"period_from"}
              label={"Treaty Period From"}
              placeholder="DD/MM/YYYY"
              type="date"
              {...form}
            />
          </div>
          <div>
            <TextInput
              required
              id={"period_to"}
              label={"Treaty Period To"}
              placeholder="DD/MM/YYYY"
              type="date"
              {...form}
            />
          </div>
        </div>
      </form>
      {form.status === "SUBMITTED" && form.isValid && <PDFRenderer url={url} />}
    </div>
  );
};

export default PaymentAllocationTab;
